<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<mat-tab-group [dynamicHeight]="false"
               [disableRipple]="true"
               animationDuration='1000ms'
               [selectedIndex]="selectedTabIndex"
               (selectedTabChange)="tabIndexChange($event)">

    <mat-tab *ngFor="let layerName of layerNames; let tabIndex = index"
             fxLayout="column" fxFlex="1 1 auto"
             [label]="getLayerDisplayName(layerName)">
        <ng-template matTabContent>
            <dash-gis-report-selector *ngIf="featureReports[layerName]?.length > 1"
                                [reportType]="'feature'"
                                [launchOptions]="featureReports[layerName]"
                                [uid]="createUid(uid, 'tab' + tabIndex)"
                                (recordCount)="setRecordCount($event, tabIndex)"
                                (reportTitle)="setReportTitle($event, tabIndex)"
                                fxLayout="column" fxFlex="1 1 auto"></dash-gis-report-selector>

            <dash-gis-feature-report *ngIf="featureReports[layerName]?.length == 1"
                               [showControls]="true"
                               [launchOptions]="featureReports[layerName][0]"
                               [uid]="createUid(uid, 'tab' + tabIndex)"
                               (overrideSubtype)='setSubtype($event)'
                               (recordCount)="setRecordCount($event, tabIndex)"
                               (reportTitle)="setReportTitle($event, tabIndex)"
                               fxLayout="column" fxFlex="1 1 auto"></dash-gis-feature-report>
        </ng-template>
    </mat-tab>
</mat-tab-group>
